export default function Global() {
  return (
    <svg
      width='42'
      height='41'
      viewBox='0 0 42 41'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_di_230_5814)'>
        <g clipPath='url(#clip0_230_5814)'>
          <rect
            x='1'
            width='40'
            height='40'
            rx='12'
            fill='url(#paint0_linear_230_5814)'
          />
          <g filter='url(#filter1_dd_230_5814)'>
            <path
              d='M22.3308 8.10431L21.2635 9.03676C21.1138 9.16782 20.8934 9.16782 20.7437 9.03676L19.6742 8.10001C19.5887 8.02482 19.4732 7.98829 19.3619 8.00333C18.6818 8.09357 17.9909 8.24396 17.2957 8.45452C13.6252 9.56744 10.7162 12.4658 9.58259 16.144C7.47785 22.9892 11.3216 29.3831 17.1652 31.3683C18.3695 31.7766 19.6593 32 21.0004 32C22.3415 32 23.6313 31.7766 24.8356 31.3683C29.5755 29.7591 33 25.2429 33 19.9426C33 13.858 28.4846 8.80902 22.6431 8.00548C22.5298 7.99044 22.4143 8.02482 22.3266 8.10216L22.3308 8.10431ZM11.2125 21.0319L11.2146 21.0297H14.9043C15.0583 21.178 15.1482 21.2639 15.3001 21.4122C15.4348 23.9796 15.9246 26.257 16.6733 28.0339C16.8209 28.3841 16.4444 28.7235 16.115 28.5366C13.4477 27.0004 11.559 24.2439 11.2082 21.034L11.2125 21.0319ZM21.0731 29.8365C21.0475 29.8386 21.0239 29.8386 21.0004 29.8386C20.9769 29.8386 20.9533 29.8386 20.9277 29.8365C19.5652 29.729 17.7599 26.5944 17.4583 21.4487C17.4454 21.2209 17.6272 21.0276 17.854 21.0276H24.1468C24.3735 21.0276 24.5554 21.2209 24.5425 21.4487C24.2409 26.5944 22.4335 29.729 21.0731 29.8365ZM25.8837 28.5366C25.5564 28.7257 25.1799 28.3841 25.3254 28.0339C26.1104 26.169 26.6088 23.754 26.7136 21.0319C26.7136 21.0297 26.7157 21.0297 26.7157 21.0297V19.2615C26.7157 19.0424 26.5382 18.864 26.32 18.864H11.6659C11.42 18.864 11.2382 18.6406 11.2767 18.3957C11.7515 15.3856 13.5803 12.8203 16.1193 11.3571C16.4487 11.1681 16.823 11.5118 16.6754 11.8642C16.13 13.1597 15.7236 14.7217 15.4883 16.4706C15.4562 16.7069 15.6444 16.9196 15.8818 16.9196H17.2529C17.4497 16.9196 17.6166 16.7714 17.6444 16.5759C18.2176 12.5474 19.7427 10.1518 20.9298 10.0573H21.0731C22.2602 10.1518 23.7875 12.5474 24.3586 16.5759C24.3864 16.7714 24.5511 16.9196 24.75 16.9196H26.1189C26.3564 16.9196 26.5446 16.7091 26.5125 16.4706C26.2815 14.7239 25.873 13.1619 25.3297 11.8642C25.1821 11.514 25.5585 11.1681 25.8858 11.3571C28.5467 12.889 30.4311 15.6348 30.7883 18.8361C30.7883 18.8533 30.7904 18.8705 30.7904 18.8877V21.0039C30.7904 21.0211 30.7904 21.0383 30.7883 21.0555C30.4311 24.2568 28.5445 27.0026 25.8837 28.5345V28.5366Z'
              fill='url(#paint1_linear_230_5814)'
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id='filter0_di_230_5814'
          x='0.5'
          y='0'
          width='41'
          height='41'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.5' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_230_5814'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_230_5814'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.5' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect2_innerShadow_230_5814'
          />
        </filter>
        <filter
          id='filter1_dd_230_5814'
          x='-23'
          y='-20.1015'
          width='88'
          height='88'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='10' />
          <feGaussianBlur stdDeviation='10' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_230_5814'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='3.89851' />
          <feGaussianBlur stdDeviation='15' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_230_5814'
            result='effect2_dropShadow_230_5814'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_230_5814'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_230_5814'
          x1='21'
          y1='0'
          x2='21'
          y2='40'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#29282C' />
          <stop offset='1' stopColor='#100F11' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_230_5814'
          x1='8.81456'
          y1='3.06879'
          x2='26.2368'
          y2='28.6055'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0.65' />
        </linearGradient>
        <clipPath id='clip0_230_5814'>
          <rect x='1' width='40' height='40' rx='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
